module.exports = __webpack_public_path__ + "static/media/Avatars_Other-27.1f3da0c1.png";